import { useState } from 'react'
import { ChevronDown, HelpCircle } from 'lucide-react'
import './SEOFAQ.css'

interface FAQItem { q: string; a: string }
interface Props { items: FAQItem[] }

export function SEOFAQ({ items }: Props) {
  const [open, setOpen] = useState<number | null>(null)
  return (
    <section className="seo-faq">
      <div className="seo-faq-inner">
        <h2 className="seo-faq-title">Häufige Fragen</h2>
        <div className="seo-faq-list">
          {items.map((item, i) => (
            <div key={i} className={`seo-faq-item ${open === i ? 'open' : ''}`}>
              <button className="seo-faq-q" onClick={() => setOpen(open === i ? null : i)}>
                <div className="seo-faq-q-inner">
                  <HelpCircle size={18} className="seo-faq-q-icon" />
                  <span>{item.q}</span>
                </div>
                <ChevronDown size={18} className={`seo-faq-chevron ${open === i ? 'rotated' : ''}`} />
              </button>
              {open === i && <div className="seo-faq-a">{item.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
